/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RecruiteeConnectionSecretsFromJSON, RecruiteeConnectionSecretsToJSON, } from './RecruiteeConnectionSecrets.js';
import { IntegrationTypeFromJSON, IntegrationTypeToJSON, } from './IntegrationType.js';
/**
 * Check if a given object implements the GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets interface.
 */
export function instanceOfGetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecrets(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
export function GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecretsFromJSON(json) {
    return GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecretsFromJSONTyped(json, false);
}
export function GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecretsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': IntegrationTypeFromJSON(json['type']),
        'data': json['data'] == null ? undefined : RecruiteeConnectionSecretsFromJSON(json['data']),
    };
}
export function GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecretsToJSON(json) {
    return GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecretsToJSONTyped(json, false);
}
export function GetOrCreateAtsIntegrationConnectionCommandDtoRecruiteeConnectionSecretsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': IntegrationTypeToJSON(value['type']),
        'data': RecruiteeConnectionSecretsToJSON(value['data']),
    };
}
